import { FormControlLabel, Switch } from '@mui/material'
import { EquipmentOperationalStatus } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { FieldBox } from '@tom-ui/ui'
import { FieldStore, IFormStore, useRegisterSubFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

interface Props<T> {
  name: keyof T
  formStore: IFormStore<T>
  initialStatus?: EquipmentOperationalStatus
}
export const OperationalEquipmentStatusSubForm = observer(
  <T,>({ name, formStore, initialStatus }: Props<T>) => {
    const { t } = useTranslate()
    const store = useRegisterSubFormStore(
      formStore,
      name,
      new FieldStore<EquipmentOperationalStatus>(EquipmentOperationalStatus.Available),
    )

    useEffect(() => {
      if (initialStatus) {
        store.setValue(initialStatus)
      }
    }, [initialStatus, store])

    return (
      <FieldBox label={t('status', 'Status')} rightRender={undefined}>
        <FormControlLabel
          control={
            <Switch
              checked={store.value === EquipmentOperationalStatus.Available}
              onChange={value =>
                store.setValue(
                  value.target.checked
                    ? EquipmentOperationalStatus.Available
                    : EquipmentOperationalStatus.Unavailable,
                )
              }
            />
          }
          label={t('available', 'Available')}
        />
      </FieldBox>
    )
  },
)
